module.exports = __webpack_public_path__ + "img/nuttagun_s.8263c522.webp";